<template>
  <c-modal
    :id="$getConst('SEO_GOOD_NEWS_MODAL_ID')"
    :padding="0"
    fluid
    overflow="hidden"
    variant="secondary"
    @close="updateRead()"
  >
    <div class="modal-body">
      <div class="row">
        <div class="col-xs-12 col-sm-4 col-logo">
          <img
            :src="require('../../../img/good-news.png')"
            alt="good news"
          >
        </div>
        <div class="col-xs-12 col-sm-8 col-results">
          <h3>Достижение целей</h3>
          <template v-if="!read.forecast && hasForecastProjects">
            <h5>Прогноз выполнен по регионам:</h5>

            <table>
              <tbody>
                <tr
                  v-for="(projects, region) in forecastProjects"
                  :key="region"
                >
                  <td class="muted">
                    <img
                      :src="require('../../../img/pin.png')"
                      alt="pin"
                      class="pin"
                    >{{ region }}
                  </td>
                  <td>
                    <template
                      v-if="projects.fix && projects.result"
                    >
                      <span class="highlight">{{ projects.fix.forecast.total_top_per }}%</span> (доп. ядро на <span class="highlight">{{ projects.result.forecast.total_top_per }}%</span>)
                    </template>
                    <span
                      v-if="projects.fix && !projects.result"
                      class="highlight"
                    >{{ projects.fix.forecast.total_top_per }}%</span>
                    <span
                      v-if="!projects.fix && projects.result"
                      class="highlight"
                    >{{ projects.result.forecast.total_top_per }}%</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </template>

          <template v-if="!read.queries && hasQueriesProjects">
            <h5>В ТОП вышли запросы, среди которых:</h5>

            <div
              v-for="(projects, region) in queriesProjects"
              :key="region"
            >
              <div
                v-for="(project, type) in projects"
                :key="project['id_parent']"
                class="region"
              >
                <img
                  :src="require('../../../img/pin.png')"
                  alt="pin"
                  class="pin"
                ><span class="highlight">{{ region }}</span><template
                  v-if="type === 'result' && projects.fix"
                >
                  (доп. ядро)
                </template>:
                <ul class="muted">
                  <li
                    v-for="query of project.queries"
                    :key="query"
                  >
                    {{ query }}
                  </li>
                </ul>
              </div>
            </div>
          </template>

          <div
            style="margin-top: 15px;"
            @click="toReport"
          >
            <router-link
              tag="button"
              class="btn btn-danger"
              :to="{ name: 'Positions'}"
            >
              Посмотреть полный отчет
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </c-modal>
</template>

<script>
import CModal from '../../../../../../../resources/js/components/ui/CModal'
import { mapGetters, mapActions, mapState } from 'vuex'
import modal from '../../../../../../../resources/js/mixins/modal'

export default {
  name: 'GoodNews',
  components: {
    CModal
  },
  mixins: [modal],
  computed: {
    ...mapState({
      read: state => state.seo.project.goodNews.read
    }),
    ...mapGetters({
      forecastProjects: 'seo/project/goodNews/forecastProjects',
      hasForecastProjects: 'seo/project/goodNews/hasForecastProjects',
      queriesProjects: 'seo/project/goodNews/queriesProjects',
      hasQueriesProjects: 'seo/project/goodNews/hasQueriesProjects'
    })
  },
  methods: {
    toReport () {
      this.hideModal(this.$getConst('SEO_GOOD_NEWS_MODAL_ID'))

      this.updateRead()
    },
    ...mapActions({
      updateRead: 'seo/project/goodNews/updateRead'
    })
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../../../../resources/css/_variables.scss";

.modal-body {
  color: white;
  padding: 30px;

  .col-logo {
    img {
      max-width: 170px;
      margin-bottom: 30px;

      @media (min-width: 768px) {
        width: 100%;
        margin-bottom: 0;
      }
    }
  }

  .col-results {
    @media (min-width: 768px) {
      padding-right: 40px;
    }

    h3 {
      text-transform: uppercase;
      margin-top: 0;
      font-weight: 600;
    }

    h5 {
      font-weight: 600;
      margin-top: 15px;
    }

    h3, h5 {
      margin-bottom: 15px;
    }

    .muted {
      color: #C6C7C8;
    }

    .highlight {
      font-weight: 600;
    }

    .pin {
      padding-right: 5px
    }

    table {
      width: 100%;
      margin-bottom: 10px;

      tr {
        td {
          padding-top: 5px;
          padding-bottom: 5px;
        }

        td:nth-child(2) {
          text-align: right;
        }
      }

      tr:not(:last-child) {
        border-bottom: 1px solid rgba(255, 255, 255, .2);
      }
    }

    .region {
      margin-bottom: 10px;

      ul {
        padding-left: 45px;
      }
    }
  }
}
</style>
